import React from 'react';
import api from "../../../services/api";
import { NavLink } from 'react-router-dom';
import GetName from './GetUserID';

var token = localStorage.getItem('user_token');

export default class ConsultaHoje extends React.Component {
  constructor() {
    super();

    this.state = {
      componentData: '',
      condition: '0',

    }; 
  }

  componentDidMount() {

    var today = new Date();
    var birthDate = new Date(this.props.data);
    console.log(birthDate);
    console.log(this.props.status);
    var age = today.getFullYear() - birthDate.getFullYear();
    console.log(age);
    var m = today.getMonth() - birthDate.getMonth();
    console.log(m);
    var d = today.getDate() - birthDate.getDate();
    console.log(birthDate.getDate());

    if ((age < 0) && (this.props.status === "Confirmada")) {
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }

    if ((age > 0) && (this.props.status === "Confirmada")) {
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m < 0 ) && (age == 0) && (this.props.status === "Confirmada")) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }

    if ((m > 0 ) && (age == 0) && (this.props.status === "Confirmada")) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m == 0) && (d == 0) && (age == 0) && (this.props.status === "Confirmada")) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 1 });
    }

    if ((m == 0) && (d > 0) && (age == 0) && (this.props.status === "Confirmada")) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 2 });
    }

    if ((m == 0) && (d < 0) && (age == 0) && (this.props.status === 'Confirmada')) {
      age--;
      console.log(age);
      this.setState({
      componentData: age,
      })
      this.setState({ condition: 0 });
    }
    
    }

    render() {
      let {condition} = this.state;
      const renderAuthButton = ()=>{
        if(condition == '1'){
          return <button id="og-button-Alerta"><GetName user_id={this.props.user_id}/></button>
        } 
        if(condition == '2'){
          return <button id="og-button-Passed"><GetName user_id={this.props.user_id}/></button>
        }
        if(condition == '0'){
          return <button id="og-button"><GetName user_id={this.props.user_id}/></button>
        } 
      }
    return (
    <>
      {renderAuthButton()}
    </>
)
}
}